import React from 'react';

function SystemDetail({ system }) {
  if (!system) return null;

  const getColorValue = (color) => {
    // Extract single color from gradient or use as is
    if (color.includes('linear-gradient')) {
      const match = color.match(/#[0-9A-Fa-f]{6}/);
      return match ? match[0] : '#0288D1';
    }
    return color;
  };

  const mainColor = getColorValue(system.color);

  return (
    <div>
      <div className="D2">
        {/* Main System Info Card */}
        <div style={{ 
          background: '#fff', 
          borderRadius: '8px', 
          border: '1px solid #E5E7EB', 
          overflow: 'hidden' 
        }}>
          {/* Header */}
          <div style={{ 
            padding: '10px 14px', 
            borderBottom: `3px solid ${mainColor}`, 
            background: '#F9FAFB' 
          }}>
            <div style={{ 
              fontSize: '9px', 
              fontWeight: '700', 
              color: mainColor, 
              letterSpacing: '1px', 
              textTransform: 'uppercase' 
            }}>
              {system.system_type}
            </div>
            <div style={{ 
              fontSize: '13px', 
              fontWeight: '800', 
              color: '#111827', 
              marginTop: '2px' 
            }}>
              {system.name}
            </div>
            <div style={{ 
              fontSize: '8px', 
              color: '#9CA3AF', 
              marginTop: '1px' 
            }}>
              {system.subtitle}
            </div>
          </div>

          {/* Dosage Tables */}
          <div style={{ padding: '12px 14px' }}>
            {system.dosage_tables && Object.entries(system.dosage_tables).map(([tableName, tableData], idx) => (
              <div key={idx} style={{ marginBottom: idx < Object.keys(system.dosage_tables).length - 1 ? '16px' : '0' }}>
                <div style={{ 
                  fontSize: '9px', 
                  fontWeight: '700', 
                  color: '#0369A1', 
                  letterSpacing: '0.5px', 
                  textTransform: 'uppercase', 
                  marginBottom: '6px' 
                }}>
                  {tableName}
                </div>
                <table style={{ 
                  width: '100%', 
                  borderCollapse: 'collapse', 
                  fontSize: '10px', 
                  marginBottom: '12px' 
                }}>
                  <thead>
                    <tr style={{ background: `${mainColor}15` }}>
                      <th style={{ 
                        padding: '5px 6px', 
                        textAlign: 'left', 
                        color: '#0369A1', 
                        fontWeight: '700', 
                        borderBottom: `2px solid ${mainColor}` 
                      }}>
                        Target BN
                      </th>
                      {tableData.components?.map((comp, cidx) => (
                        <th key={cidx} style={{ 
                          padding: '5px 6px', 
                          textAlign: 'center', 
                          color: '#0369A1', 
                          fontWeight: '700', 
                          borderBottom: `2px solid ${mainColor}` 
                        }}>
                          {comp}
                        </th>
                      ))}
                      <th style={{ 
                        padding: '5px 6px', 
                        textAlign: 'center', 
                        color: '#0369A1', 
                        fontWeight: '700', 
                        borderBottom: `2px solid ${mainColor}` 
                      }}>
                        Total Treat
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.rows?.map((row, ridx) => (
                      <tr key={ridx} style={{ background: ridx % 2 === 1 ? '#F8FAFC' : 'transparent' }}>
                        <td style={{ 
                          padding: '4px 6px', 
                          color: '#374151', 
                          fontWeight: '700', 
                          borderBottom: ridx === tableData.rows.length - 1 ? `2px solid ${mainColor}` : '1px solid #E5E7EB'
                        }}>
                          {row.target}
                        </td>
                        {row.values?.map((val, vidx) => (
                          <td key={vidx} style={{ 
                            padding: '4px 6px', 
                            textAlign: 'center', 
                            color: '#374151', 
                            fontFamily: 'monospace', 
                            borderBottom: ridx === tableData.rows.length - 1 ? `2px solid ${mainColor}` : '1px solid #E5E7EB'
                          }}>
                            {val}
                          </td>
                        ))}
                        <td style={{ 
                          padding: '4px 6px', 
                          textAlign: 'center', 
                          color: '#0369A1', 
                          fontWeight: '800', 
                          fontFamily: 'monospace', 
                          borderBottom: ridx === tableData.rows.length - 1 ? `2px solid ${mainColor}` : '1px solid #E5E7EB'
                        }}>
                          {row.total}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>

        {/* Component Properties Card */}
        {system.component_properties && Object.keys(system.component_properties).length > 0 && (
          <div style={{ 
            background: '#fff', 
            borderRadius: '8px', 
            border: '1px solid #E5E7EB', 
            overflow: 'hidden', 
            marginTop: '8px' 
          }}>
            <div style={{ 
              padding: '10px 14px', 
              borderBottom: '1px solid #E5E7EB', 
              background: '#F9FAFB' 
            }}>
              <div style={{ 
                fontSize: '9px', 
                fontWeight: '700', 
                color: '#6B7280', 
                letterSpacing: '1px', 
                textTransform: 'uppercase' 
              }}>
                Component Properties
              </div>
            </div>
            <div style={{ padding: '12px 14px' }}>
              {Object.entries(system.component_properties).map(([compName, props], idx) => (
                <div key={idx}>
                  <div style={{ 
                    fontSize: '10px', 
                    fontWeight: '800', 
                    color: idx === 0 ? '#03A9F4' : mainColor, 
                    marginBottom: '6px' 
                  }}>
                    {compName}
                  </div>
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: '1fr 1fr 1fr', 
                    gap: '6px', 
                    marginBottom: idx < Object.keys(system.component_properties).length - 1 ? '10px' : '0',
                    paddingBottom: idx < Object.keys(system.component_properties).length - 1 ? '10px' : '0',
                    borderBottom: idx < Object.keys(system.component_properties).length - 1 ? '1px solid #E5E7EB' : 'none'
                  }}>
                    {Object.entries(props).map(([propName, propValue], pidx) => (
                      <div key={pidx}>
                        <div style={{ 
                          fontSize: '7px', 
                          color: '#9CA3AF', 
                          fontWeight: '600' 
                        }}>
                          {propName}
                        </div>
                        <div style={{ 
                          fontSize: '11px', 
                          fontWeight: '800', 
                          color: '#111827', 
                          fontFamily: 'monospace' 
                        }}>
                          {propValue}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* System Advantage */}
        {system.advantage && (
          <div style={{ 
            background: `${mainColor}04`, 
            borderRadius: '8px', 
            border: `1px solid ${mainColor}12`, 
            padding: '12px', 
            borderLeft: `3px solid ${mainColor}`, 
            marginTop: '8px' 
          }}>
            <div style={{ 
              fontSize: '9px', 
              fontWeight: '700', 
              color: mainColor, 
              letterSpacing: '1px', 
              textTransform: 'uppercase', 
              marginBottom: '4px' 
            }}>
              System Advantage
            </div>
            <div style={{ 
              fontSize: '11px', 
              color: '#374151', 
              lineHeight: '1.5' 
            }}>
              {system.advantage}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SystemDetail;
